export default function (theme) {
    return {
        MuiRadio: {
            root: {
                color: theme.palette.primary.main
            },
            colorSecondary: {
                color: theme.palette.text.disabled,
                '&$checked': {
                    color: theme.palette.secondary.dark
                }
            },
        }
    };
}